<template>
    <div>
        <mt-cell v-if="param.readonly" :title="model.caption" :readonly="param.readonly" :titlewidth="titlewidth" :value-align="textalign">
            <div class="em-select-value mt-color-grey-lv3">
                <template>{{currentValue}}</template>
            </div>
        </mt-cell>
        <mt-field v-if="!param.readonly" v-model="currentValue" :placeholder="placeholder" :label="model.caption" :readonly="!!param.readonly" :disabled="!!param.disabled" :type="type" :disable-clear="!!param.readonly || !!param.disabled"  :required="param.required && !param.readonly" @change.native="handleChange" :titlewidth="titlewidth" :value-align="textalign"></mt-field>
    </div>
</template>
<script>
export default {

    name: 'emInput',

    props: {
        model: {
            type: Object,
            default: function() {
                return {};
            }
        },
        value: null,
        titlewidth:{
            type: String,
            default: function() {
                return '';
            }
        },
        textalign:{
            type: String,
            default: function() {
                return '';//flex-start
            }
        }
    },

    data() {
        return {
            currentValue: this.value
        };
    },

    watch: {
        value(val) {
            this.currentValue = val;
        },
        currentValue(val) {
            this.$emit('input', val);
        }
    },

    computed: {
        type() {
            let xtype = this.model.xtype;
            switch (xtype) {
                case 'number':
                    return 'number';
                case 'textarea':
                    return 'textarea';
                default:
                    return 'text';
            }
        },
        placeholder() {
            if (this.param.readonly) {
                return '';
            }
            if (this.param.placeholder) {
                return this.param.placeholder;
            }
            return '请输入' + this.model.caption;
        },
        param() {
            return this.model.initParam;
        }
    },

    methods: {
        handleChange() {
            this.$emit('change', this.currentValue);
        }
    }
}
</script>
<style lang="css">
</style>


// WEBPACK FOOTER //
// emInput.vue?ef5d5856